import { Map } from 'immutable';

export function update(state, action) {
    if (!action.data.id) {
        action.data.id = action.id;
    }

    return bulk(
        state,
        {
            data: [
                action.data
            ]
        }
    );
}

export function bulk(state, action) {
    let items = state.get('items');

    action.data.forEach((competition) => {
        let item = items.get(+competition.id) || Map();

        items = items.set(+competition.id, item.merge(competition));
    });

    return state.set('items', items);
}
